export function convertToSelectedTimezone(utcTime: string | number | Date, timezone: string): string {
    return utcTime.toString();
    try {
        const utcDate = new Date(utcTime);
        if (isNaN(utcDate.getTime())) {
            throw new Error("Invalid UTC format");
        }

        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: timezone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
        
        const parts = formatter.formatToParts(utcDate);
        const year = parts.find(part => part.type === 'year')?.value || "";
        const month = parts.find(part => part.type === 'month')?.value || "";
        const day = parts.find(part => part.type === 'day')?.value || "";
        const hour = parts.find(part => part.type === 'hour')?.value || "";
        const minute = parts.find(part => part.type === 'minute')?.value || "";
        const second = parts.find(part => part.type === 'second')?.value || "";
        
        return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
    } catch (error) {
        console.error("Error in converting time:", error);
        return "Invalid Timezone or UTC format";
    }
}

export function convertToSelectedTimezoneFormatted(utcTime: string | number | Date, timezone: string): string {
    return utcTime.toString();
    try {
        const utcDate = new Date(utcTime);
        if (isNaN(utcDate.getTime())) {
            throw new Error("Invalid UTC format");
        }

        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: timezone,
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: 'numeric',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        });
        
        return formatter.format(utcDate);
    } catch (error) {
        console.error("Error in converting time:", error);
        return "Invalid Timezone or UTC format";
    }
}

export function convertToSelectedTimeZoneIntoDate(utcTime: string | number | Date, timezone: string): string {
    return utcTime.toString();
    try {
        const utcDate = new Date(utcTime);
        if (isNaN(utcDate.getTime())) {
            throw new Error("Invalid UTC format");
        }

        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: timezone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
        
        const parts = formatter.formatToParts(utcDate);
        const year = parts.find(part => part.type === 'year')?.value || "";
        const month = parts.find(part => part.type === 'month')?.value || "";
        const day = parts.find(part => part.type === 'day')?.value || "";
        
        return `${day}/${month}/${year}`;
    } catch (error) {
        console.error("Error in converting time:", error);
        return "Invalid Timezone or UTC format";
    }
}